module.exports = __webpack_public_path__ + "img/login-img.07586243.jpg";